<template>
  <button class="button" :disabled="disabled" @click="handleClick">
    {{ title }}
  </button>
</template>

<script setup>
// Propsを定義
defineProps({
  title: String,
  disabled: Boolean,
});

// クリックイベントを定義
const emit = defineEmits(['click']);

// クリックイベントハンドラ
const handleClick = () => {
  emit('click');
};
</script>

<style scoped>
.button {
  width: 100%;
  margin: 0;
  padding: 1.2rem;
  border-radius: 1rem;
  background-color: #21963b;
  font-size: 2rem;
  font-weight: bold;
}
</style>
